import React from 'react';
import {useTranslation} from 'react-i18next';
import {toPriceStr} from '@/utils';
import {goTo} from '@/utils';
import {UserTotal} from '@/common-pages/invitation/invitation.type';
import ChevronRightIcon from '@/pages/agent/components/svgs/chevron-right';

const rewardCardBg = require('@/pages/agent/assets/reward-card-bg.webp');

interface StatsCardsProps {
  userTotal?: UserTotal | null;
}

const StatsCards: React.FC<StatsCardsProps> = ({userTotal}) => {
  const {t} = useTranslation();
  const handleTotalRewardsClick = () => {
    goTo('InvitationRecord');
  };

  const handleTotalInvitesClick = () => {
    goTo('InvitationRecord');
  };

  return (
    <div className="flex flex-row gap-3">
      {/* Total Rewards Card */}
      <div
        className="bg-white h-[4.4375rem] overflow-hidden relative rounded-lg shrink-0 w-[10.75rem] cursor-pointer"
        onClick={handleTotalRewardsClick}>
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{backgroundImage: `url(${rewardCardBg})`}}
        />

        {/* Content */}
        <div className="absolute flex flex-col gap-2 items-center justify-center size-full px-3">
          <div className="flex flex-row items-center gap-1">
            <p className="font-bold text-sm text-t1">
              {t('agent.invitation-reward.totalRewards')}
            </p>
          </div>
          <div className="flex items-center justify-center gap-1">
            <p className="text-lg font-bold text-[#F15802]">
              {toPriceStr(userTotal?.bonusAmountTotal || 0, {fixed: 0})}
            </p>
            <ChevronRightIcon
              className="absolute right-3 bottom-3 size-4"
              color="var(--T3)"
            />
          </div>
        </div>
      </div>

      {/* Total Invites Card */}
      <div
        className="bg-white h-[4.4375rem] overflow-hidden relative rounded-lg shrink-0 w-[10.75rem] cursor-pointer"
        onClick={handleTotalInvitesClick}>
        {/* Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{backgroundImage: `url(${rewardCardBg})`}}
        />

        {/* Content */}
        <div className="absolute flex flex-col gap-2 items-center justify-center size-full px-3">
          <div className="flex flex-row items-center gap-1">
            <p className="font-bold text-sm text-t1">
              {t('agent.invitation-reward.totalInvites')}
            </p>
          </div>
          <div className="flex items-center justify-center gap-1">
            <p className="text-lg font-bold text-[#F15802]">
              {userTotal?.invitedNumberTotal || 0}
            </p>
            <ChevronRightIcon
              className="absolute right-3 bottom-3 size-4"
              color="var(--T3)"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
